<template>
    <div class="titan-date-picker">
        <font-awesome-icon :icon="value !== null ? 'times' : 'calendar-alt'"
                           @click="updateValue(null)"
                           class="calendar-icon"
        ></font-awesome-icon>
        <datepicker
                :placeholder="schema.placeholder"
                format="dd.MM.yyyy"
                :value="value"
                :language="language"
                :monday-first="true"
                v-on:selected="updateValue"
                v-on:cleared="updateValue"
                v-on:input="updateValue"
                :bootstrap-styling="true"
                :highlighted="highlighted"
                :disabled-dates="disabledCalendar"
        />
    </div>
</template>
<script>
    import {abstractField} from "vue-form-generator"
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';
    import * as translatorLocales from 'vuejs-datepicker/dist/locale'

    export default {
        mixins: [abstractField],
        components: {
            Datepicker
        },
        created() {
            if (this.value !== null && this.value !== undefined) {
                this.value = moment(this.value).format('YYYY-MM-DD');
            } else {
                this.value = null
            }
        },
        computed: {
            disabledCalendar() {
                return {
                    'to': this.schema.minDate === undefined ? null : this.schema.minDate
                };
            },
            language() {
                const locale =  this.schema.language === undefined ? 'en' : this.schema.language;
                return translatorLocales[locale];
            }
        },
        methods: {
            updateValue(date) {
                if (date === null) {
                    this.value = date;
                } else {
                    this.value = moment.utc(date, this.inputFormat).format('YYYY-MM-DD');
                }
            }
        },
        data() {
            return {
                inputFormat: 'dd.MM.yyyy',
                highlighted: {
                    dates: [
                        new Date()
                    ]
                }
            }
        }
    };
</script>
<style lang="scss">
    $primaryColor: #009DFA ! default;
    $secondaryText: #ffffff ! default;

    .titan-date-picker {
        position: relative;

        .calendar-icon {
            position: absolute;
            right: 10px;
            z-index: 10;
            top: 10px;
            color: #8a8a8a;
        }

        .vdp-datepicker {
            .form-control {
                background: #fff;
                cursor: pointer;
            }
        }

        .vdp-datepicker__calendar {
            border-color: $primaryColor ! important;
            width: 247px ! important;
            border-radius: 4px;

            header {
                > span {
                    background: darken($primaryColor, 5%);
                    color: $secondaryText;

                    &:hover {
                        background: darken($primaryColor, 8%) ! important;
                    }
                }

                .prev:after {
                    border-right-color: $secondaryText ! important;
                }
                .next:after {
                    border-left-color: $secondaryText ! important;
                }
            }

            .day-header {
                background: $primaryColor;
                color: $secondaryText;
                margin-bottom: 2px;

                &:hover {
                    background: $primaryColor ! important;
                }
            }

            .cell {
                height: 35px ! important;
                line-height: 35px ! important;
                font-size: 0.8rem;

                &.highlighted {
                    border-radius: 3px;
                }

                &.selected {
                    border-radius: 3px;
                    background: $primaryColor ! important;
                    color: $secondaryText;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/Form/Fields/Datepicker.vue